import React from 'react'
import styled from 'styled-components'
import { Accordion } from 'semantic-ui-react'

import type { WidgetType } from 'components/Admin/FeedbackWidgetSettings'

type WidgetPresetSelectorProps = {
  type: WidgetType
  onSelect: Function
  className?: string
  gridPresets
  carouselPresets
  masonryPresets
  popupBoxPresets
  scorePresets
}

export default function WidgetPresetSelector({
  type,
  onSelect,
  className,
  gridPresets,
  carouselPresets,
  masonryPresets,
  popupBoxPresets,
  scorePresets,
}: WidgetPresetSelectorProps) {
  function getPresets(type: WidgetType) {
    if (type === 'grid') {
      return gridPresets
    }
    if (type === 'carousel') {
      return carouselPresets
    }
    if (type === 'masonry') {
      return masonryPresets
    }
    if (type === 'popup_box') {
      return popupBoxPresets
    }
    if (type === 'score') {
      return scorePresets
    }
    return []
  }
  const presets = getPresets(type)
  return (
    <Accordion
      fluid
      styled
      exclusive={false}
      className={className}
      panels={[
        {
          key: 'preset',
          title: { children: <span>Preset</span> },
          content: {
            children: (
              <div>
                <CardGroup>
                  {presets?.map((preset) => (
                    <WidgetPresetCard key={preset.label} preset={preset} onSelect={onSelect} />
                  ))}
                </CardGroup>
              </div>
            ),
          },
        },
      ]}
    />
  )
}

function WidgetPresetCard({ preset, onSelect }) {
  return (
    <Card
      onClick={() => {
        onSelect(preset)
      }}
      className="flex flex-col justify-between w-full cursor-pointer"
    >
      <img src={preset.image} alt={preset.label} />
      <div>
        <h3 className="p-3 text-center text-black">{preset.label}</h3>
      </div>
    </Card>
  )
}

const CardGroup = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, minmax(180px, 1fr));
  }
`

const Card = styled.div`
  transition: 0.1s;

  &:hover {
    transform: translateY(-3px);
  }
`



// WEBPACK FOOTER //
// ./src/components/WidgetPresetSelector/index.tsx